module.exports = __webpack_public_path__ + "img/outStockTips.a3865c7d.svg";